import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const CouponDetailPage = lazy(() => import('@/pages/coupons/detail'));

export const Route = createFileRoute('/coupons/$id')({
  component: function CouponRoute() {
    const { id } = Route.useParams();
    return (
      <Suspense fallback={<TableSkeleton />}>
        <CouponDetailPage couponId={id} />
      </Suspense>
    );
  },
});
